const quick = [
  {
    icon: "ri-error-warning-line",
    tag: "处罚",
    tone: "bg-primary-500",
    title: "直播内容专项治理通报",
    desc: "一批涉违规直播账号被分级处置，处置标准成讨论焦点",
    meta: "处罚 · 今日热议",
  },
  {
    icon: "ri-eye-off-line",
    tag: "下架",
    tone: "bg-foreground-800",
    title: "低质短剧批量下架",
    desc: "涉及诱导充值与搬运混剪，下架范围与依据引发争议",
    meta: "下架 · 新增索引",
  },
  {
    icon: "ri-shield-check-line",
    tag: "审核",
    tone: "bg-secondary-600",
    title: "审核机制公开说明更新",
    desc: "算法规则文档改版，创作者合规成本再被讨论",
    meta: "审核 · 文档追踪",
  },
  {
    icon: "ri-earth-line",
    tag: "监管",
    tone: "bg-accent-600",
    title: "属地监管约谈动向",
    desc: "平台整改要求逐条落地，责任边界仍存疑问",
    meta: "监管 · 多方核实中",
  },
];

export default function QuickScan() {
  return (
    <section className="w-full border-y border-background-200/70 bg-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-3 px-4 py-8 sm:grid-cols-2 md:px-6 lg:grid-cols-4 lg:gap-4">
        {quick.map((q) => (
          <a
            key={q.title}
            href="#hot"
            className="group flex flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
          >
            <div className="flex items-center justify-between">
              <span className={`inline-flex h-8 w-8 items-center justify-center rounded-lg text-background-50 ${q.tone}`}>
                <i className={`${q.icon} text-sm`} />
              </span>
              <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                {q.meta}
              </span>
            </div>
            <div>
              <h3 className="font-label text-[15px] font-semibold leading-snug text-foreground-950 group-hover:text-primary-700">
                {q.title}
              </h3>
              <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{q.desc}</p>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}